// extracted by mini-css-extract-plugin
module.exports = {"typeCard":"type-card_typeCard__2bLQ6"};